export function parseMarkdown(text: string): string {
  let html = text

  // Handle tables first
  const tableRegex = /(\|.+\|[\r\n]+)+/g
  html = html.replace(tableRegex, (table) => {
    const rows = table.trim().split('\n').filter(r => r.trim())
    if (rows.length < 2) return table

    let tableHtml = '<table>'
    rows.forEach((row, i) => {
      if (row.includes('---')) return
      const cells = row.split('|').filter(c => c.trim())
      if (i === 0) {
        tableHtml += `<thead><tr>${cells.map(c => `<th>${c.trim()}</th>`).join('')}</tr></thead><tbody>`
      } else {
        tableHtml += `<tr>${cells.map(c => `<td>${c.trim()}</td>`).join('')}</tr>`
      }
    })
    tableHtml += '</tbody></table>'
    return tableHtml
  })

  // Headers
  html = html.replace(/^### (.*$)/gm, '<h3>$1</h3>')
  html = html.replace(/^## (.*$)/gm, '<h2>$1</h2>')
  html = html.replace(/^# (.*$)/gm, '<h1>$1</h1>')

  // Bold
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')

  // Lists
  html = html.replace(/^\- (.*$)/gm, '<li>$1</li>')
  html = html.replace(/(<li>.*<\/li>\n?)+/g, '<ul>$&</ul>')

  // Paragraphs
  const parts = html.split(/\n\n+/)
  html = parts.map(part => {
    part = part.trim()
    if (!part) return ''
    if (part.startsWith('<h') || part.startsWith('<table') || part.startsWith('<ul')) return part
    return `<p>${part.replace(/\n/g, '<br>')}</p>`
  }).join('\n')

  return html
}
